import { createContext, useContext, useState, useCallback } from "react";
import Cookies from "js-cookie";
import { fetchUserDataRequest } from "services";
import {
  getSessionCookieRemoveOptions,
  parseUserDataCookieOrNull,
  removeUserDataCookie,
} from "utils/common/userCookie";

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => parseUserDataCookieOrNull());

  const logout = useCallback(() => {
    const opts = getSessionCookieRemoveOptions();
    removeUserDataCookie(opts);
    Cookies.remove("access", opts);
    Cookies.remove("token", opts);
    localStorage.clear();
    setUser(null);
  }, []);

  const fetchUserData = useCallback(async () => {
    const token = Cookies.get("token");
    if (!token) {
      logout();
      return;
    }
    try {
      const { data: payload, errors } = await fetchUserDataRequest();
      if (errors || payload?.status !== 200 || payload?.data == null) {
        logout();
        return;
      }
      const profile = payload.data;
      setUser((currentUser) => {
        if (JSON.stringify(currentUser) !== JSON.stringify(profile)) {
          return profile;
        }
        return currentUser;
      });
    } catch (error) {
      logout();
    }
  }, [logout]);

  const value = { user, logout, fetchUserData };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

const useUser = () => useContext(UserContext);

export { UserProvider, useUser };
